import getFilterParametersUrl from "./getFilterParametersUrl";

const getProductTypeFilter = (search: string) => {
  const activeFilters = getFilterParametersUrl(search);
  return activeFilters.find((filter) => /mb_product_type_filter/.test(filter));
};

export default getProductTypeFilter;
